// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NGcW","placeholdersHeader":"styles_placeholdersHeader__3K3-k","editorStyle":"styles_editorStyle__2YC7F","placeholdersBox":"styles_placeholdersBox__CT9p2"};